import i18n from "i18next";

export const validateName = (name: string | undefined): string | undefined => {
  const regex = /^[a-zA-Z0-9\s\-!@#\$%\^\&*\)\(+=._-]+$/;
  const chineseRegex = /^[\u4e00-\u9fa5]+$/;

  if (!name) return i18n.t("nameRequired");
  if (!regex.test(name) && !chineseRegex.test(name))
    return i18n.t("invalidNameFormat");

  return undefined;
};

export const validateHKID = (hkid: string | undefined): string | undefined => {
  const regex = /^[A-Z]{1,2}[0-9]{6}[A0-9]$/;
  // if (!hkid) return i18n.t('hkidRequired');
  if (hkid && !regex.test(hkid)) return i18n.t("invalidHKIDFormat");
  return undefined;
};

export const validatePhoneNumber = (
  countryCode: string | undefined,
  mobileNo: string | undefined
) => {
  if (!countryCode || !mobileNo) {
    return i18n.t("phoneRequired");
  }

  const regexMap: Record<string, RegExp> = {
    "852": /^[456789]\d{7}$/, // Hong Kong
    "853": /^[67]\d{7}$/, // Macau
    "86": /^\d{11}$/, // China (only check length)
  };

  const regex = regexMap[countryCode];
  if (!regex.test(mobileNo)) {
    return i18n.t("invalidPhoneFormat");
  }

  return undefined;
};

export const validateEmail = (
  email: string | undefined
): string | undefined => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email) return i18n.t("emailRequired");
  if (!regex.test(email)) return i18n.t("invalidEmailFormat");
  return undefined;
};

export const validateEHealth = (
  eHealth: string | undefined
): string | undefined => {
  if (!eHealth) return i18n.t("eHealthRequired");
  return undefined;
};

export const validateBookingNo = (
  bookingNo: string | undefined
): string | undefined => {
  if (!bookingNo) return i18n.t("bookingNoRequired");
  return undefined;
};
